import { React, useEffect, useState } from "react";
import TopBanner from "../../../components/topBanner/topBanner";
import imgBaner from "../../../images/banner/banner---gioi-thieu.png";
import TitleCenter from "../../../components/title/TitleCenter";
import { getCustomersByLanguage } from "../../../apis/customers";
import { getAdminCustomers } from "../../../apis/adminCustomers";
import { useLanguage } from "../../../hooks/useLanguage";
import { useNavigate, useLocation } from "react-router-dom";

const CUSTOMER_GROUPS = [
  {
    menuId: 20,
    titleKey: "customers_menu.strategic_partners_hospital",
    fallbackTitle: "Đối tác chiến lược bệnh viện",
    slugs: ["doi-tac-chien-luoc-benh-vien", "strategic-partners-hospital"],
  },
  {
    menuId: 70,
    titleKey: "customers_menu.strategic_partners_tech",
    fallbackTitle: "Đối tác chiến lược công nghệ",
    slugs: ["doi-tac-chien-luoc-cong-nghe", "strategic-partners-tech"],
  },
  {
    menuId: 19,
    titleKey: "customers_menu.typical_customers",
    fallbackTitle: "Khách hàng tiêu biểu",
    slugs: ["khach-hang-tieu-bieu", "typical-customers"],
  }
];

const getCustomerItems = (response) => {
  if (Array.isArray(response?.items)) return response.items;
  if (Array.isArray(response?.data?.items)) return response.data.items;
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response)) return response;
  return [];
};

const createCustomerGroups = (customers = [], t) =>
  CUSTOMER_GROUPS.map((config) => {
    const groupCustomers = customers
      .filter((customer) => Number(customer.navMenuId) === config.menuId)
      .filter((customer) => customer.isActive !== false)
      .sort((a, b) => (Number(a.sortOrder) || 0) - (Number(b.sortOrder) || 0));

    const translated = t(config.titleKey);
    const navMenuTitle =
      translated && translated !== config.titleKey
        ? translated
        : config.fallbackTitle;

    return {
      navMenuId: config.menuId,
      navMenuTitle,
      customers: groupCustomers,
    };
  }).filter((group) => group.customers.length > 0);

const selectCustomerGroups = (groups = []) =>
  groups
    .filter((group) => Array.isArray(group?.customers) && group.customers.length > 0)
    .sort((a, b) => {
      const getPriority = (id) => {
        if (Number(id) === 20) return 0; // Đối tác chiến lược (Strategic partners) LUÔN ở đầu
        if (Number(id) === 19) return 1; // Khách hàng tiêu biểu thứ 2
        return Number(id) + 10;
      };
      return getPriority(a.navMenuId) - getPriority(b.navMenuId);
    });

function ListCustomer() {
  const { t, currentLang } = useLanguage();
  const [groups, setGroups] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const expectedBasePath =
      currentLang === "vi" ? "/tong-quan/khach-hang-doi-tac" : "/about-us/customers-partners";
    const currentPath = location.pathname;

    if (
      currentPath.includes("khach-hang-doi-tac") ||
      currentPath.includes("customers-partners")
    ) {
      if (!currentPath.startsWith(expectedBasePath)) {
        navigate(expectedBasePath, { replace: true });
      }
    }
  }, [currentLang, location.pathname, navigate]);

  useEffect(() => {
    const loadCustomerGroups = async () => {
      try {
        // This endpoint already returns the translated NavMenu title stored in
        // the database.  Do not rebuild the public headings from i18n keys.
        const apiGroups = selectCustomerGroups(await getCustomersByLanguage(currentLang));
        if (apiGroups.length > 0) {
          setGroups(apiGroups);
          return;
        }
      } catch {
        // Retain the Admin response only as a compatibility fallback for older
        // API deployments that do not return grouped customer data yet.
      }

      try {
        const response = await getAdminCustomers({
          pageIndex: 1,
          pageSize: 1000,
          languageCode: currentLang,
          isActive: true,
        });
        setGroups(createCustomerGroups(getCustomerItems(response), t));
      } catch {
        setGroups([]);
      }
    };

    loadCustomerGroups();
  }, [currentLang, t]);

  const isInsideIntroduce =
    location.pathname.startsWith("/gioi-thieu") ||
    location.pathname.startsWith("/tong-quan") ||
    location.pathname.startsWith("/about-us");

  return (
    <div className="news_controller customers-page">
      {!isInsideIntroduce && (
        <TopBanner
          titleCenter={t("menu.customers")}
          imgBanner={imgBaner}
          pageName={t("menu.customers")}
        />
      )}
      <div className="layout_container customers-page__content">
        {groups.map((group) => (
          <section className="customers-group" key={group.navMenuId}>
            <div className="customers-group__heading">
              <TitleCenter text={group.navMenuTitle} />
            </div>
            <div className="customers_container">
                <ul className="customers_grid customers_grid--enhanced">
                  {group.customers.map((customer, index) => (
                    <li
                      className="customer-card-motion"
                      key={customer.id}
                      style={{ "--customer-delay": `${index * 90}ms` }}
                    >
                      {customer.websiteUrl && customer.websiteUrl !== "#" ? (
                        <a
                          href={customer.websiteUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          title={customer.websiteUrl}
                          className="customer-card__inner"
                        >
                          <img src={customer.logoImage} alt={customer.name} />
                          <span className="customer-card__link" aria-hidden="true">{"\u2197\uFE0E"}</span>
                        </a>
                      ) : (
                        <div className="customer-card__inner">
                          <img src={customer.logoImage} alt={customer.name} />
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}

export default ListCustomer;
